(function() {
    'use strict';
    angular.module('app').controller('AffiliatesSalesController', AffiliatesSalesController);
        AffiliatesSalesController.$inject=[
            '$scope',
            'AffiliateTableService',
            'PromoCodeTableService',
            'AffiliateService'
        ]
        
        function AffiliatesSalesController (
            $scope,
            AffiliateTableService,
            PromoCodeTableService,
            AffiliateService){
            const vm = this;
            vm.partners=[]
            init();

            function init(){
                getAllPartners();
                $scope.tableData = new AffiliateTableService(vm.partners).tableData;
                $scope.promoCodeTableData = new PromoCodeTableService().tableData;
            }

            function getAllPartners(){
                AffiliateService.getAllcompanyPartners(
                    res=>{
                       const data = res.content
                       data.forEach(item => {
                           vm.partners.push({
                               value:item.name,
                               name:item.name
                           })
                       });

                      
                    },err=>{

                    },
                    {
                        size:50
                    }
                )
            }

        }
})();


// WEBPACK FOOTER //
// ./js/controllers/AffiliatesSales.js